
import { combineReducers } from 'redux';
import authReducer from './authReducer';
import musicPlayerReducer from './musicPlayerReducer';
import cmsDataReducer from './cmsDataReducer';
import categoryReducer from './categoryReducer';
import languageReducer  from './languageReducer'
const rootReducer = combineReducers({
    auth: authReducer,
    musicPlayerDetails: musicPlayerReducer,
    cmsData: cmsDataReducer,
    categorySlug: categoryReducer, 
    languageReudx: languageReducer,
});

export default rootReducer;
